<template>
  <div id="docPage" :class="theme">
    <div class="infobar"><div class="subbar"><h1>{{name }}</h1></div></div>
    <div class="pageContent">
      <div class="mainBlock">
      <div class="block" v-for="(item) in sps" v-bind:key="item.id" :class="item.flex" >

        </div>
      </div>

    </div>
</div>
</template>

<script>
export default {
  name: "docPage",
  props:{
    urlPath:String,
    name:String,
    theme: String,
    sps:Array,
  }
}
</script>

<style scoped>

.block {
  margin: 1em auto;
}
.fa-play-circle{
margin-left:-1px;}
video{
  display:inline;
  margin:0 auto;
  border: .5em solid var(--secondlight);
  width:100%;
  margin:-1em;
}

.gameBlock{
  display:flex;
font-size:1em;
  align-items: center;
}

.subbar
{
  display:flex;
  width:100%;
  justify-content: space-between;
}

.gameBlock a{
  font-family: lemonmilk;
  font-display: swap;
  width:110px;
  display:block;
  border: .25em solid var(--darkbg);
  outline: .2em solid var(--second);
  padding:0.35em 1.2em;
  text-decoration:none;
  text-align:center;
  color:var(--second);
  transition: all 0.2s;
}
.gameBlock a:hover{
  color:var(--secondlight);
  background: var(--second);
  border: .25em solid var(--second);

}

.sidebar {
  flex: 1;
  max-height: 6em;
  padding-left: 15px;
  border-left: solid 3px var(--second);
  font-size: 24px;
  position: -webkit-sticky;
  position: sticky;

  margin-left: 1em;
  top: 11.5rem;
}

.sidebar .share-network-facebook{
  display:block;
  width:25px;
}
.sidebar i{
  color:var(--second);
  margin-bottom:8px;
}

.sidebar i:hover{
  color:var(--primarylight);
  cursor:pointer;
}


.mainBlock{flex: 0 1 940px;
max-width:940px;
margin-bottom:3em;}


.image img{
  border: .5em solid var(--secondlight);
  width:100%;
  margin:-1em;
}

#docPage{
  display:flex;
  flex-grow:1;
  color:black;
  font-family: 'montserrat';
  overflow-y:scroll;
  flex-direction:column;
  align-items: stretch;
  height:100vh;
  font-size:14px;
}

.infobar{

  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: var(--secondlight);
  padding: 0 50px;
  flex: 0 0 150px;
  display:flex;
  flex-direction: column;
  justify-content: center;
}

.infobar h1{
  font-family: 'lemonmilk';
  font-display: swap;
  font-size: 2em;
  vertical-align: top;
  letter-spacing:.1em;
  text-align: left;
  margin:0.25em 0em;
  color: var(--second);
}

.pageContent h2{
  margin-bottom:5px;
  margin-top:0;
  font-family: lemonmilk;
  font-display: swap;
  font-size:1rem;
  letter-spacing: .2em;
}

.pageContent{
  display:flex;
  flex-direction:row;
  flex:1;

  padding:0px 50px;
  margin-top:30px;
}


#docPage::-webkit-scrollbar-track {
  background: var(--second);
  border: 4px solid var(--darkbg)!important;
  border-radius: 10px;
}

#docPage::-webkit-scrollbar-thumb {
  background: var(--darkbg);
  border: 4px solid var(--second);
}

-webkit-scrollbar:hover{
  cursor:pointer;
}

#docPage::-webkit-scrollbar-thumb:hover {
  background: var(--second);
  border: 4px solid var(--seconddark);
}

#docPage::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background: var(--second);}

</style>